/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OtherArticleNamesDto } from './other-article-names-dto';
import { ValidationDTO } from './validation-dto';
import { ProductInternalResponseDto } from './product-internal-response-dto';
import { OrganizationDto } from './organization-dto';


export interface DossierDto { 
    /**
     * ID
     */
    id: number;
    /**
     * Simplified submissions
     */
    simplifiedSubmissions: number;
    /**
     * SCIP number
     */
    scipNumber: string;
    /**
     * UUID
     */
    uuid: string;
    /**
     * Title
     */
    title: string;
    /**
     * Name
     */
    name: string;
    /**
     * Remarks
     */
    remarks: string;
    /**
     * Internal remarks
     */
    internalRemarks: string;
    /**
     * Submission number
     */
    submissionNumber: string;
    /**
     * Dossier Submission Status
     */
    status: DossierDtoStatusEnum;
    /**
     * Submission date
     */
    submissionDate: string;
    /**
     * Filename
     */
    filename: string;
    /**
     * ECHA response ref type
     */
    refType: string;
    /**
     * ECHA response ref value
     */
    refValue: string;
    /**
     * ECHA response report URL
     */
    reportUrl: string;
    org: OrganizationDto;
    /**
     * Requested type
     */
    requestedType: DossierDtoRequestedTypeEnum;
    /**
     * Dossier type
     */
    type: DossierDtoTypeEnum;
    /**
     * Dossier ID
     */
    dossierId: number;
    /**
     * Validations
     */
    validations: Array<ValidationDTO>;
    /**
     * Parent identity
     */
    parentIdentity: string;
    simplifiedParentDossier: DossierDto;
    parentPartsProduct: ProductInternalResponseDto;
    /**
     * Updated at
     */
    updatedAt: string;
    /**
     * Created at
     */
    createdAt: string;
    product: ProductInternalResponseDto;
    /**
     * Resource ID
     */
    resourceId: number;
    /**
     * Echa submission response status
     */
    echaResponseStatus: DossierDtoEchaResponseStatusEnum;
    /**
     * Echa submission response error text
     */
    echaResponseErrorText: string;
    /**
     * Organization group name
     */
    orgGroupName: string;
    /**
     * Other article names
     */
    otherArticleNames: Array<OtherArticleNamesDto>;

    /**
     * Force Resubmission on VP level
     */
    forceResubmission: Boolean;
}
export enum DossierDtoStatusEnum {
    DossierRequested = 'DOSSIER_REQUESTED',
    DossierFileInPreparation = 'DOSSIER_FILE_IN_PREPARATION',
    DossierFailedToCreate = 'DOSSIER_FAILED_TO_CREATE',
    DossierFileCreated = 'DOSSIER_FILE_CREATED',
    DossierSentToEcha = 'DOSSIER_SENT_TO_ECHA',
    Pending = 'PENDING',
    Submitted = 'SUBMITTED',
    AllPartsCompleted = 'ALL_PARTS_COMPLETED',
    OneOrMoreFailed = 'ONE_OR_MORE_FAILED',
    ValidationSucceeded = 'VALIDATION_SUCCEEDED',
    Failed = 'FAILED',
    ValidationFailed = 'VALIDATION_FAILED',
    DossierTooLarge = 'DOSSIER_TOO_LARGE'
};
export enum DossierDtoRequestedTypeEnum {
    Standard = 'STANDARD',
    PartsOnly = 'PARTS_ONLY',
    Referencing = 'REFERENCING'
};
export enum DossierDtoTypeEnum {
    Full = 'FULL',
    Simplified = 'SIMPLIFIED'
};
export enum DossierDtoEchaResponseStatusEnum {
    ClientError = 'CLIENT_ERROR',
    FailedAuthenticationChecks = 'FAILED_AUTHENTICATION_CHECKS',
    FailedAuthorisationChecks = 'FAILED_AUTHORISATION_CHECKS',
    ServiceNotFound = 'SERVICE_NOT_FOUND',
    RefusedRequestUnsupportedFormat = 'REFUSED_REQUEST_UNSUPPORTED_FORMAT',
    ServerError = 'SERVER_ERROR',
    NetworkErrorWhileSubmitting = 'NETWORK_ERROR_WHILE_SUBMITTING',
    DossierFileCreationError = 'DOSSIER_FILE_CREATION_ERROR',
    UndefinedStatusCode = 'UNDEFINED_STATUS_CODE',
    DossierSentToEcha = 'DOSSIER_SENT_TO_ECHA'
};



